// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpPackPitch-cls1_XQ9","cls2":"LoswpPackPitch-cls2_YDr LoswpPackPitch-cls1_XQ9"};